"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _showAPIError["default"];
  }
});
var _showAPIError = _interopRequireDefault(require("./showAPIError"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }